import { CSSProperties } from 'react';
import BaseSmall, { ButtonProps } from '../Base/small';

import { ButtonVariant } from '../Default';

type StyleType = {
  containerStyle: CSSProperties;
  textStyle: CSSProperties;
};

const STYLES: Record<ButtonVariant, StyleType> = {
  primary: {
    containerStyle: {
      backgroundColor: '#0092FF',
      boxShadow: '0px 1px 2px 0px rgba(12, 18, 30, 0.05)',
    },
    textStyle: {
      color: '#fff',
    },
  },
  secondary: {
    containerStyle: {
      border: '1px solid #0092FF',
    },
    textStyle: {
      color: '#0092FF',
    },
  },
  danger: {
    containerStyle: {
      border: '1px solid #FF4B30',
    },
    textStyle: {
      color: '#FF4B30',
    },
  },
  black: {
    containerStyle: {
      border: '1px solid #000',
    },
    textStyle: {
      color: '#000',
    },
  },
  clear: {
    containerStyle: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    textStyle: {
      color: '#0092FF',
    },
  },
  ['clear-danger']: {
    containerStyle: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    textStyle: {
      color: '#FF4B30',
    },
  },
  disabled: {
    containerStyle: {
      backgroundColor: '#D8F0FE',
    },
    textStyle: {
      color: '#fff',
    },
  },
  blue: {
    containerStyle: {
      backgroundColor: '#0A313F',
    },
    textStyle: {
      color: '#FFFFFF',
    },
  },
};

type Props = ButtonProps & {
  variant?: ButtonVariant;
  showChevron?: boolean;
};

export const UISmallButton = (props: Props) => {
  const { variant = 'primary' } = props;

  return <BaseSmall {...props} containerStyle={STYLES[variant].containerStyle} textStyle={STYLES[variant].textStyle} />;
};
